import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, CircularProgress, Container } from "@mui/material";
import { appApi } from "../../apis/config";

export const TermsOfService = () => {
  const [terms, setTerms] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const res = await appApi.get("terms-of-service");
        if (res.data?.success) {
          setTerms(res.data.terms);
        }
      } catch (err) {
        console.error("Failed to load Terms of Service:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Paper elevation={3} sx={{ p: { xs: 3, sm: 6 }, borderRadius: 3 }}>
        <Typography variant="h4" component="h1" fontWeight={700} sx={{ mb: 4, color: "#1976d2", borderBottom: "2px solid #1976d2", pb: 2 }}>
          Terms of Service
        </Typography>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box 
            className="terms-content" 
            sx={{ 
              lineHeight: 1.7, 
              color: "#333",
              fontSize: "1.05rem",
              "& p": { mb: 2 },
              "& ul, & ol": { pl: 3, mb: 2 }
            }}
            dangerouslySetInnerHTML={{ __html: terms }}
          />
        )}
      </Paper>
    </Container>
  );
};

export default TermsOfService;
